/**
 * Internal API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CodeResultViewV2 } from '../model/codeResultViewV2';
// @ts-ignore
import { TerminalConfigResultView } from '../model/terminalConfigResultView';
// @ts-ignore
import { TerminalDeviceInsertView } from '../model/terminalDeviceInsertView';
// @ts-ignore
import { TerminalDeviceResultView } from '../model/terminalDeviceResultView';
// @ts-ignore
import { TerminalGroupInsertView } from '../model/terminalGroupInsertView';
// @ts-ignore
import { TerminalGroupPutView } from '../model/terminalGroupPutView';
// @ts-ignore
import { TerminalGroupResultView } from '../model/terminalGroupResultView';
// @ts-ignore
import { UpdateSessionRequestView } from '../model/updateSessionRequestView';
// @ts-ignore
import { UpdateTerminalDeviceRequestView } from '../model/updateTerminalDeviceRequestView';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { InternalConfiguration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class TerminalPosService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: InternalConfiguration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/TerminalPos/CheckSession
     * @param xScheme 
     * @param xApiKey 
     * @param terminalId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosCheckSessionGet(xScheme: string, xApiKey: string, terminalId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosCheckSessionGet(xScheme: string, xApiKey: string, terminalId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosCheckSessionGet(xScheme: string, xApiKey: string, terminalId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosCheckSessionGet(xScheme: string, xApiKey: string, terminalId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosCheckSessionGet.');
        }
        if (xApiKey === null || xApiKey === undefined) {
            throw new Error('Required parameter xApiKey was null or undefined when calling apiTerminalPosCheckSessionGet.');
        }
        if (terminalId === null || terminalId === undefined) {
            throw new Error('Required parameter terminalId was null or undefined when calling apiTerminalPosCheckSessionGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>terminalId, 'terminalId');

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-ApiKey', String(xApiKey));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/CheckSession`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/GenerateCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosGenerateCodeGet(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CodeResultViewV2>;
    public apiTerminalPosGenerateCodeGet(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CodeResultViewV2>>;
    public apiTerminalPosGenerateCodeGet(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CodeResultViewV2>>;
    public apiTerminalPosGenerateCodeGet(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/GenerateCode`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CodeResultViewV2>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/RefreshTerminalConfig/{terminal_id}
     * @param xScheme 
     * @param terminalId 
     * @param deviceId 
     * @param deviceMake 
     * @param deviceModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosRefreshTerminalConfigTerminalIdGet(xScheme: string, terminalId: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalConfigResultView>;
    public apiTerminalPosRefreshTerminalConfigTerminalIdGet(xScheme: string, terminalId: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalConfigResultView>>;
    public apiTerminalPosRefreshTerminalConfigTerminalIdGet(xScheme: string, terminalId: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalConfigResultView>>;
    public apiTerminalPosRefreshTerminalConfigTerminalIdGet(xScheme: string, terminalId: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosRefreshTerminalConfigTerminalIdGet.');
        }
        if (terminalId === null || terminalId === undefined) {
            throw new Error('Required parameter terminalId was null or undefined when calling apiTerminalPosRefreshTerminalConfigTerminalIdGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceId, 'deviceId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceMake, 'deviceMake');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceModel, 'deviceModel');

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/RefreshTerminalConfig/${this.configuration.encodeParam({name: "terminalId", value: terminalId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalConfigResultView>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/SetupTerminalConfig/{code}
     * @param code 
     * @param deviceId 
     * @param deviceMake 
     * @param deviceModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosSetupTerminalConfigCodeGet(code: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalConfigResultView>;
    public apiTerminalPosSetupTerminalConfigCodeGet(code: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalConfigResultView>>;
    public apiTerminalPosSetupTerminalConfigCodeGet(code: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalConfigResultView>>;
    public apiTerminalPosSetupTerminalConfigCodeGet(code: string, deviceId?: string, deviceMake?: string, deviceModel?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling apiTerminalPosSetupTerminalConfigCodeGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceId, 'deviceId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceMake, 'deviceMake');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceModel, 'deviceModel');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/SetupTerminalConfig/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalConfigResultView>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/TerminalDevice
     * @param xScheme 
     * @param terminalGroup 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalDeviceGet(xScheme: string, terminalGroup: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosTerminalDeviceGet(xScheme: string, terminalGroup: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosTerminalDeviceGet(xScheme: string, terminalGroup: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosTerminalDeviceGet(xScheme: string, terminalGroup: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalDeviceGet.');
        }
        if (terminalGroup === null || terminalGroup === undefined) {
            throw new Error('Required parameter terminalGroup was null or undefined when calling apiTerminalPosTerminalDeviceGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>terminalGroup, 'terminalGroup');

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalDevice`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/TerminalPos/TerminalDevice
     * @param xScheme 
     * @param terminalDeviceInsertView 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalDevicePost(xScheme: string, terminalDeviceInsertView: TerminalDeviceInsertView, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalDeviceResultView>;
    public apiTerminalPosTerminalDevicePost(xScheme: string, terminalDeviceInsertView: TerminalDeviceInsertView, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalDeviceResultView>>;
    public apiTerminalPosTerminalDevicePost(xScheme: string, terminalDeviceInsertView: TerminalDeviceInsertView, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalDeviceResultView>>;
    public apiTerminalPosTerminalDevicePost(xScheme: string, terminalDeviceInsertView: TerminalDeviceInsertView, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalDevicePost.');
        }
        if (terminalDeviceInsertView === null || terminalDeviceInsertView === undefined) {
            throw new Error('Required parameter terminalDeviceInsertView was null or undefined when calling apiTerminalPosTerminalDevicePost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalDevice`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalDeviceResultView>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminalDeviceInsertView,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint delete /api/TerminalPos/TerminalDevice/{terminal_device_id}
     * @param xScheme 
     * @param terminalDeviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalDeviceTerminalDeviceIdDelete(xScheme: string, terminalDeviceId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdDelete(xScheme: string, terminalDeviceId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdDelete(xScheme: string, terminalDeviceId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdDelete(xScheme: string, terminalDeviceId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdDelete.');
        }
        if (terminalDeviceId === null || terminalDeviceId === undefined) {
            throw new Error('Required parameter terminalDeviceId was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalDevice/${this.configuration.encodeParam({name: "terminalDeviceId", value: terminalDeviceId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/TerminalDevice/{terminal_device_id}
     * @param xScheme 
     * @param terminalDeviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalDeviceTerminalDeviceIdGet(xScheme: string, terminalDeviceId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalConfigResultView>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdGet(xScheme: string, terminalDeviceId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalConfigResultView>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdGet(xScheme: string, terminalDeviceId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalConfigResultView>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdGet(xScheme: string, terminalDeviceId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdGet.');
        }
        if (terminalDeviceId === null || terminalDeviceId === undefined) {
            throw new Error('Required parameter terminalDeviceId was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalDevice/${this.configuration.encodeParam({name: "terminalDeviceId", value: terminalDeviceId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalConfigResultView>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint put /api/TerminalPos/TerminalDevice/{terminal_device_id}
     * @param xScheme 
     * @param terminalDeviceId 
     * @param updateTerminalDeviceRequestView 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalDeviceTerminalDeviceIdPut(xScheme: string, terminalDeviceId: string, updateTerminalDeviceRequestView: UpdateTerminalDeviceRequestView, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalConfigResultView>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdPut(xScheme: string, terminalDeviceId: string, updateTerminalDeviceRequestView: UpdateTerminalDeviceRequestView, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalConfigResultView>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdPut(xScheme: string, terminalDeviceId: string, updateTerminalDeviceRequestView: UpdateTerminalDeviceRequestView, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalConfigResultView>>;
    public apiTerminalPosTerminalDeviceTerminalDeviceIdPut(xScheme: string, terminalDeviceId: string, updateTerminalDeviceRequestView: UpdateTerminalDeviceRequestView, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdPut.');
        }
        if (terminalDeviceId === null || terminalDeviceId === undefined) {
            throw new Error('Required parameter terminalDeviceId was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdPut.');
        }
        if (updateTerminalDeviceRequestView === null || updateTerminalDeviceRequestView === undefined) {
            throw new Error('Required parameter updateTerminalDeviceRequestView was null or undefined when calling apiTerminalPosTerminalDeviceTerminalDeviceIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalDevice/${this.configuration.encodeParam({name: "terminalDeviceId", value: terminalDeviceId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalConfigResultView>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateTerminalDeviceRequestView,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/TerminalPos/TerminalGroup
     * @param xScheme 
     * @param terminalGroupInsertView 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalGroupPost(xScheme: string, terminalGroupInsertView: TerminalGroupInsertView, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalGroupResultView>;
    public apiTerminalPosTerminalGroupPost(xScheme: string, terminalGroupInsertView: TerminalGroupInsertView, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupPost(xScheme: string, terminalGroupInsertView: TerminalGroupInsertView, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupPost(xScheme: string, terminalGroupInsertView: TerminalGroupInsertView, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalGroupPost.');
        }
        if (terminalGroupInsertView === null || terminalGroupInsertView === undefined) {
            throw new Error('Required parameter terminalGroupInsertView was null or undefined when calling apiTerminalPosTerminalGroupPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalGroup`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalGroupResultView>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminalGroupInsertView,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint delete /api/TerminalPos/TerminalGroup/{terminal_group_id}
     * @param xScheme 
     * @param terminalGroupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalGroupTerminalGroupIdDelete(xScheme: string, terminalGroupId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosTerminalGroupTerminalGroupIdDelete(xScheme: string, terminalGroupId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdDelete(xScheme: string, terminalGroupId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdDelete(xScheme: string, terminalGroupId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdDelete.');
        }
        if (terminalGroupId === null || terminalGroupId === undefined) {
            throw new Error('Required parameter terminalGroupId was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalGroup/${this.configuration.encodeParam({name: "terminalGroupId", value: terminalGroupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/TerminalGroup/{terminal_group_id}
     * @param xScheme 
     * @param terminalGroupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalGroupTerminalGroupIdGet(xScheme: string, terminalGroupId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalGroupResultView>;
    public apiTerminalPosTerminalGroupTerminalGroupIdGet(xScheme: string, terminalGroupId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdGet(xScheme: string, terminalGroupId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdGet(xScheme: string, terminalGroupId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdGet.');
        }
        if (terminalGroupId === null || terminalGroupId === undefined) {
            throw new Error('Required parameter terminalGroupId was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalGroup/${this.configuration.encodeParam({name: "terminalGroupId", value: terminalGroupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalGroupResultView>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint put /api/TerminalPos/TerminalGroup/{terminal_group_id}
     * @param xScheme 
     * @param terminalGroupId 
     * @param terminalGroupPutView 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalGroupTerminalGroupIdPut(xScheme: string, terminalGroupId: string, terminalGroupPutView: TerminalGroupPutView, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminalGroupResultView>;
    public apiTerminalPosTerminalGroupTerminalGroupIdPut(xScheme: string, terminalGroupId: string, terminalGroupPutView: TerminalGroupPutView, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdPut(xScheme: string, terminalGroupId: string, terminalGroupPutView: TerminalGroupPutView, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminalGroupResultView>>;
    public apiTerminalPosTerminalGroupTerminalGroupIdPut(xScheme: string, terminalGroupId: string, terminalGroupPutView: TerminalGroupPutView, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdPut.');
        }
        if (terminalGroupId === null || terminalGroupId === undefined) {
            throw new Error('Required parameter terminalGroupId was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdPut.');
        }
        if (terminalGroupPutView === null || terminalGroupPutView === undefined) {
            throw new Error('Required parameter terminalGroupPutView was null or undefined when calling apiTerminalPosTerminalGroupTerminalGroupIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalGroup/${this.configuration.encodeParam({name: "terminalGroupId", value: terminalGroupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminalGroupResultView>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminalGroupPutView,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/TerminalPos/TerminalGroups
     * @param xScheme 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosTerminalGroupsGet(xScheme: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosTerminalGroupsGet(xScheme: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosTerminalGroupsGet(xScheme: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosTerminalGroupsGet(xScheme: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosTerminalGroupsGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/TerminalGroups`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/TerminalPos/UpdateSession/{sessionId}
     * @param xScheme 
     * @param xApiKey 
     * @param sessionId 
     * @param updateSessionRequestView 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTerminalPosUpdateSessionSessionIdPost(xScheme: string, xApiKey: string, sessionId: string, updateSessionRequestView: UpdateSessionRequestView, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiTerminalPosUpdateSessionSessionIdPost(xScheme: string, xApiKey: string, sessionId: string, updateSessionRequestView: UpdateSessionRequestView, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiTerminalPosUpdateSessionSessionIdPost(xScheme: string, xApiKey: string, sessionId: string, updateSessionRequestView: UpdateSessionRequestView, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiTerminalPosUpdateSessionSessionIdPost(xScheme: string, xApiKey: string, sessionId: string, updateSessionRequestView: UpdateSessionRequestView, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xScheme === null || xScheme === undefined) {
            throw new Error('Required parameter xScheme was null or undefined when calling apiTerminalPosUpdateSessionSessionIdPost.');
        }
        if (xApiKey === null || xApiKey === undefined) {
            throw new Error('Required parameter xApiKey was null or undefined when calling apiTerminalPosUpdateSessionSessionIdPost.');
        }
        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling apiTerminalPosUpdateSessionSessionIdPost.');
        }
        if (updateSessionRequestView === null || updateSessionRequestView === undefined) {
            throw new Error('Required parameter updateSessionRequestView was null or undefined when calling apiTerminalPosUpdateSessionSessionIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xScheme !== undefined && xScheme !== null) {
            localVarHeaders = localVarHeaders.set('X-Scheme', String(xScheme));
        }
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-ApiKey', String(xApiKey));
        }

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/TerminalPos/UpdateSession/${this.configuration.encodeParam({name: "sessionId", value: sessionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateSessionRequestView,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
